<template>
<span class="minus">
-
</span>
</template>
